import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Julkaisun jälkeen',
  subtitle: 'Tarkastele julkaisun tarkistuslistan tietoja ja aseta julkaisun jälkeisen tarkastuksen päivämäärä.',
  go_live_checklist: {
    labels: {
      yes: 'Kyllä',
      no: 'Ei',
    },
    title: 'Julkaisun tarkistuslista',
    form: {
      is_google_business_available: {
        label: 'Google Business käytettävissä',
      },
      is_smart_pricing_configured: {
        label: 'Edullisemmat hinnat kuin Lieferandolla, Woltilla, Uberilla',
      },
      is_flyers_package_sent: {
        label: 'Mainosesite lähetetty',
      },
      is_menu_fully_configured: {
        label: 'Kaikki ruokalistan tuotteet saatavilla',
      },
      has_offers_on_competitor_platforms: {
        label:
          'Onko ravintolalla käynnissä tarjouksia Woltissa, Uberissa, Lieferandolla (lukuun ottamatta ilmaisen toimituksen tarjousta)?',
      },
      is_instagram_story_shared: {
        label: 'Instagram-tarina jaettu omistajan kanssa',
      },
      is_order_system_connected_to_website: {
        label: 'Foodamigos-verkkosivusto yhdistetty TAI ravintolan oman verkkosivuston tilauspainike lisätty',
      },
      google_business_connected_by: {
        label: 'Miten saimme pääsyn Google Business -profiiliin?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
            'Myyntipäällikkö kutsui osoitteen google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Myyntipäällikkö lähetti ensimmäisen pyynnön itse omistajan puhelimesta',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Käyttöönottopäällikkö pyysi Google Business -profiilia (myyntipäällikkö ei kutsunut eikä pyytänyt pääsyä)',
          null: 'Ei sovellettavissa',
        },
      },
    },
    buttons: {
      save: 'Tallenna',
    },
    toasts: {
      success: 'Tallennettu onnistuneesti',
      error: 'Tallentaminen epäonnistui',
    },
  },
  post_launch_screening: {
    title: 'Julkaisun jälkeinen tarkastus',
    form: {
      screening_date: {
        label: 'Tarkastuspäivä',
      },
    },
    toasts: {
      success: 'Tallennettu onnistuneesti',
      error: 'Tallentaminen epäonnistui',
    },
    buttons: {
      save: 'Tallenna',
    },
  },
};
